// Tab-scoped recovery metadata only. Never persist a password, verification code,
// token, or authenticated state. Server verification remains authoritative.
const KEY = 'henosis.pendingRegistration.v1';
const TTL = 30 * 60 * 1000;
const experiences = new Set(['chat', 'remote', 'later']);

export function readPendingRegistration(now = Date.now()) {
  try {
    const data = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!data || data.version !== 1 || !Number.isFinite(data.expiresAt) || data.expiresAt <= now || data.expiresAt > now + TTL ||
      typeof data.email !== 'string' || data.email.length > 254 || !data.email.includes('@') ||
      typeof data.username !== 'string' || data.username.length > 150 || !experiences.has(data.experience)) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return { email: data.email, username: data.username, experience: data.experience };
  } catch (_) { return null; }
}
export function savePendingRegistration({ email, username, experience }, now = Date.now()) {
  if (typeof email !== 'string' || !email.includes('@') || email.length > 254 || typeof username !== 'string' || username.length > 150 || !experiences.has(experience)) return false;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ version: 1, expiresAt: now + TTL, email, username, experience }));
    return true;
  } catch (_) { return false; }
}
export function clearPendingRegistration() {
  try { sessionStorage.removeItem(KEY); } catch (_) { /* Private storage may be unavailable. */ }
}
